import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Megaphone, AlertTriangle } from 'lucide-react';

export default function ResidentAnnouncements() {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/resident/announcements').then(res => setAnnouncements(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const priorityColor = (p) => ({ urgent: 'bg-red-50 text-red-700 border-red-100', important: 'bg-orange-50 text-orange-700 border-orange-100', normal: 'bg-slate-100 text-slate-600' }[p] || 'bg-slate-100 text-slate-600');

  if (loading) return <div className="flex items-center justify-center h-64"><div className="loading-spinner" /></div>;

  return (
    <div data-testid="resident-announcements">
      <h1 className="text-xl font-bold text-slate-900 font-['Outfit'] mb-4">Announcements</h1>

      <div className="space-y-4">
        {announcements.length === 0 && <p className="text-sm text-slate-400 text-center py-12">No announcements yet</p>}
        {announcements.map(a => (
          <Card key={a.announcement_id} className="border-slate-100" data-testid={`resident-ann-${a.announcement_id}`}>
            <CardContent className="p-4">
              <div className="flex items-start gap-3">
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${a.priority === 'urgent' ? 'bg-red-50' : 'bg-emerald-50'}`}>
                  {a.priority === 'urgent' ? (
                    <AlertTriangle size={16} className="text-red-600" />
                  ) : (
                    <Megaphone size={16} className="text-emerald-600" />
                  )}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm font-semibold text-slate-900 font-['Outfit']">{a.title}</h3>
                    <Badge className={`text-[10px] ${priorityColor(a.priority)}`}>{a.priority}</Badge>
                  </div>
                  <p className="text-sm text-slate-600 leading-relaxed">{a.content}</p>
                  <div className="flex items-center gap-2 mt-2">
                    <span className="text-[10px] text-slate-400">by {a.created_by_name || 'Admin'}</span>
                    <span className="text-[10px] text-slate-400">{new Date(a.created_at).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
